const en = {
  'language.english': 'English',
  'language.spanish': 'Spanish',
};

export default en;
